import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 48px;
	min-height: 48px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${colors.grey3};
	padding: 0 32px;
	background-color: ${colors.white};
	z-index: 1;
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 16px;
	align-self: center;
`;

export const ControlsWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-left: auto;
`;

export const TabsWrapper = styled.div`
	display: flex;
`;

export const OptionLabel = styled.div`
	width: 240px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Label = styled.div`
	font-weight: 400;
	font-size: 13px;
	color: ${colors.grey5};
	padding-right: 4px;
`;

export const RightWrapper = styled.div`
	display: flex;
	align-items: center;
`;
